import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.season.loading.season');
import { OnInit, Input } from '@angular/core';

@Component({
    selector: 'wiz-portal-season-loading-season',
template: templateSource || '',
    styles: [``],
})
export class PortalSeasonLoadingSeasonComponent implements OnInit {
    @Input() height: number = 36;

    constructor() { }

    public async ngOnInit() {
    }
}

export default PortalSeasonLoadingSeasonComponent;